import { SQLMetaInfo, SqlState } from '@pages/Sql/types';
import { getPipelines } from '@pages/Sql/utils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useGetProjectPipelines = () => {
  const metainfoPipelines = useSelector<SqlState, SQLMetaInfo['pipelines']>(getPipelines);

  return useMemo(() => {
    return Object.values(metainfoPipelines || {}).filter((pipeline) => Boolean(pipeline.path));
  }, [metainfoPipelines]);
};

export default useGetProjectPipelines;
